module.exports = __webpack_public_path__ + "static/media/a92f04d5-56bb-4951-aaa9-a91b21038e05.5f640e58.png";